import { Pane, Spinner } from 'evergreen-ui'
import React, { useEffect } from 'react'
import {useHistory } from 'react-router-dom';

function PageLoader() {
const history = useHistory()


    useEffect(() => {
        setTimeout(()=>{
            history.push(`/`);
        }, 5000);
    }, [history])
    
  return (
    <div>
        <Pane display="flex" alignItems="center" justifyContent="center" height={400}>
            <Spinner />
        </Pane>
    </div>
  )
}

export default PageLoader